module.exports = __webpack_public_path__ + "static/activities-pic-01-68152c15819e6bf2d946e97bb4a11fa3.jpg";